import { store } from './store';
import { actionCreators } from '../containers/Auth/ducks/reducer';

export default () =>
  new Promise(() => {
    store.dispatch(actionCreators.checkAuthorization());
  });
